var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpectCirclesLinesTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.977,
    height: 1066.942,
    viewBox: "0 0 145.977 1066.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(67.705 -35.813) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(245.646 547.063)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 6.909,
    ry: 6.909,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 5.909,
    ry: 5.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    transform: "translate(117.009 243.639)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 6.909,
    ry: 6.909,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 5.909,
    ry: 5.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(456.042 764.874)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.091,
    cy: 5.091,
    r: 5.091,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.091,
    cy: 5.091,
    r: 4.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(360.693 654.022)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 6.909,
    ry: 6.909,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 5.909,
    ry: 5.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(374.511 598.751)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.636,
    cy: 3.636,
    rx: 3.636,
    ry: 3.636,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.636,
    cy: 3.636,
    rx: 2.636,
    ry: 2.636,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(247.968 336.209)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.636,
    cy: 3.636,
    rx: 3.636,
    ry: 3.636,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.636,
    cy: 3.636,
    rx: 2.636,
    ry: 2.636,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(504.031 960.555)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 6.909,
    ry: 6.909,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 5.909,
    ry: 5.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    transform: "translate(196.02 219.818)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 6.909,
    ry: 6.909,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.909,
    cy: 6.909,
    rx: 5.909,
    ry: 5.909,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 13.091,
    y2: 14.545,
    transform: "translate(328.744 520.883)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 12.363,
    y2: 10.909,
    transform: "translate(0 105.625)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M8.259,0,0,19.847",
    transform: "translate(372.758 757.598)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M0,0,12.118,17.623",
    transform: "translate(564.339 848.221)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 16,
    y2: 4.364,
    transform: "translate(250.513 422.39)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 16,
    y2: 4.364,
    transform: "translate(73.561 0)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 11.636,
    y2: 14.182,
    transform: "translate(465.866 689.171)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 11.636,
    y2: 14.182,
    transform: "translate(318.09 448.055)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 11.636,
    y2: 14.182,
    transform: "translate(69.755 204.296)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectCirclesLinesTablet);
export default __webpack_public_path__ + "static/media/expectCirclesLinesTablet.0054b5c07b5b64600082025c42a39320.svg";
export { ForwardRef as ReactComponent };